import { Component, OnInit, Output, Input, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { StsConfigService } from 'app/services/sts-config.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { StsGuid } from 'app/models/sts-guid';
import { StsNotification } from 'app/models/sts-notification.model';
import { StsNotificationType } from 'app/models/sts-notification-type';
import { StsCaptcha } from 'app/models/sts-captcha.model';

@Component({
  selector: 'app-sts-text-captcha',
  templateUrl: './sts-text-captcha.component.html',
  styleUrls: ['./sts-text-captcha.component.scss']
})
export class StsTextCaptchaComponent implements OnInit {
  @Output() onValidate: EventEmitter<any> = new EventEmitter();
  @ViewChild('divCaptcha') divCaptcha: ElementRef;

  public isProd = false;
  public cfg: StsConfigService;
  private guid: string = null;
  private kk = '_sts_capcallbaks';
  private kk2 = '_sts_subm';

  public passed = false;
  public submitted = false;
  public showCaptchaError = false;
  public captchaText = '';
  private _captchaUrl: string;

  constructor(
    private httpClient: HttpClient,
    private config: StsConfigService) {
      this.cfg = config;
      this.isProd = config.isProduction();

      if (this.cfg.isProduction()) {
        if (!this.onValidate) {
          throw 'invalid usage of captcha control';
        }

        this.guid = StsGuid.newGuid();

        // ---------------------------------------------------------------------------------------
        // don't know the purpose of this
        if (!document.hasOwnProperty(this.kk)) {
          document[this.kk] = {};
        }

        if (!document.hasOwnProperty(this.kk2)) {
          document[this.kk2] = {};
        }

        if (!document[this.kk].hasOwnProperty(this.guid)) {
          document[this.kk][this.guid] = (args, args2) => this.onValidate.emit(
            {
              textCaptchaKey1: args,
              textCaptchaKey2: args2,
              textCaptchaVal: this._getCaptchaValue()
            }
          );
        }
        // ---------------------------------------------------------------------------------------
      }

      this._setCaptchaUrl();
      this.reset();
    }

  ngOnInit() {
    this.submitted = false;
  }

  private _setCaptchaUrl(): void {
    this._captchaUrl = `/ArielSecurityRegisterUser/RegisterCaptcha?hook=${this.kk}
      &hook2=${this.kk2}&_=${this.guid}&__=${StsGuid.newGuid()}`;
  }

  private _getCaptcha() {
    // get
    this.httpClient
      .get(this._captchaUrl, {
        responseType: 'text'
      })
      .subscribe(
        html => {
          const body = this._getBody(html);
          this._renderCaptcha(body);
        },
        err => console.log(err)
      );
  }

  private  _getCaptchaValue(): string {
    return this.captchaText;
  }

  private _postCaptcha() {
    this.submitted = true;
    let obj = this.divCaptcha.nativeElement.querySelector('#CaptchaDeText');
    if (!obj) {
      setTimeout(() => {
        this._postCaptcha();
      }, 200);
      return;
    }
    const deText = obj.value;
    const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');
    const bodyStr = `CaptchaDeText=${deText}&CaptchaInputText=${this.captchaText}`;

    // post
    this.httpClient
      .post(this._captchaUrl, bodyStr, {
        headers,
        responseType: 'text'
      })
      .subscribe(
        html => {
          this._validateCaptcha(html);
        },
        err => console.log(err)
      );
  }

  private _renderCaptcha(body) {
    const captcha = body.split('<br/>')[1].trim();
    if (this.divCaptcha.nativeElement.innerHTML === '') {
      // first time insert html
      this.divCaptcha.nativeElement.insertAdjacentHTML('beforeend', captcha);
    } else {
      // html exist, just update the img.src and input.value
      const img = this.divCaptcha.nativeElement.querySelector('img');
      const input = this.divCaptcha.nativeElement.querySelector('input');
      const code = captcha.split('value="')[1].split('"')[0];
      const src = `/DefaultCaptcha/Generate?t=${code}`;
      img.src = src;
      input.value = code;
    }
  }

  private _validateCaptcha(html) {
    let capchaObj: StsCaptcha = {
      textCaptchaKey1: '',
      textCaptchaKey2: '',
      textCaptchaVal: this._getCaptchaValue()
    };


    if (html.indexOf('<body class="ariel-captcha">') > -1) {
      const body = this._getBody(html);

      if (body.indexOf('form') > -1) {
        // error, render the captcha again
        this._renderCaptcha(body);
      } else {
        // success
        const scriptArr = body.split('<script>')[1].trim().split('\'');
        capchaObj.textCaptchaKey1 = scriptArr[1];
        capchaObj.textCaptchaKey2 = scriptArr[3];
      }
    }

    this.onValidate.emit(capchaObj);
  }

  private _getBody(html) {
    return html.split('<body class="ariel-captcha">')[1].split('</body>')[0].trim();
  }


  public getAnother() {
    this.submitted = false;
    event.preventDefault();   // prevent <a></a> default behaviour
    this.reset();
  }

  public reset(): void {
    this.passed = false;
    this._getCaptcha();
  }

  public submit(): void {
    if (!this.isProd) {
      // document[this.kk][this.guid](this.recaptchaResponse);

    } else {
      if (this.passed) {
        this.onValidate.emit(null);     // it will pass the captcha check
      } else {
        this._postCaptcha();
      }
    }
  }

  public checkForCaptchaError(captcha: StsCaptcha): StsNotification {
    if (!this.passed && !captcha.textCaptchaKey1 && this.isProd) {
      let err = new StsNotification();
      err.code = 'sts-captcha-invalid';
      err.description = 'Sorry, we couldn\'t verify your captcha response';
      err.level = StsNotificationType.Error;
      this.passed = false;
      this.showCaptchaError = true;
      return err;
    }

    this.passed = true;
    return null;
  }
}
